<template>
    <div class="record-search-wrapper d-inline-block">
        <input name="new_keep_ids" type="hidden" :value="jsonRecords">

        <div class="text-right">
            <button type="button" class="btn btn-secondary js-btn-toggle" v-on:click="display(true)">
                <i class="fas fa-hand-pointer mr-1"></i>
                &nbsp;{{ $t('record_search.btn') }}
            </button>
        </div>

        <div :class="'modal-backdrop fade' + (this.displayModal ? ' show' : ' d-none')"></div>

        <div ref="modal" :class="'modal modal--top fade in' + (this.displayModal ? ' show' : '')" id="compareFilter" tabindex="-1"
             role="dialog" aria-labelledby="comparingFilterLabel"
             aria-hidden="true">

            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <!--                        <button v-show="this.displayRecords" type="button" class="btn btn-transparent" data-dismiss="modal" v-on:click="displayRecordList(false)"  >-->
                        <!--                            <i class="fas fa-arrow-left"></i>-->
                        <!--                        </button>-->
                        <h5 class="modal-title" id="comparingFilterLabel">
                            {{ $t('record_search.modal_title') }}
                        </h5>
                        <!--                        <button type="button" class="btn btn-outline-secondary float-right" aria-label="Zavřít" v-on:click="display(false)">-->
                        <!--                            <i class="fas fa-times mr-md-1"></i>-->
                        <!--                            <span class="d-none d-md-inline-block" aria-hidden="true">Zavřít</span>-->
                        <!--                        </button>-->
                        <button type="button" class="close" aria-label="Close" v-on:click="display(false)">
                            <span aria-hidden="true">&#10005;</span>
                        </button>
                    </div>

                    <div class="modal-body form-with-labels">

                        <div v-show="!this.displayRecords">

                            <div class="form-row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="form-label"
                                               for="district">{{ $t('parameters.district') }}</label>
                                        <district-select
                                            @update:text="(text) => district = text"
                                            :selected="district.value"
                                            :error="false"
                                            dropdownParent="#compareFilter"
                                        ></district-select>
                                    </div>
                                </div>
                                <div class="col-md-9 col-md-9 mb-5 mb-md-0">
                                    <label class="form-label mb-3">{{ $t('parameters.area_size') }}</label>
                                    <div class="range-box">
                                        <form>
                                            <div style="position:relative; margin-left: 15px; width:95%">
                                                <span class="output"><span id="myValue"></span></span>
                                                <input v-model="range" type="range" name="range" id="myRange"
                                                       class="slider"
                                                       data-inited="false" max="5" min="0" value="2"
                                                       style="width:100%">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>


                            <div class="row mb-4 mb-md-0">
                                <div v-if="['flat', 'house'].includes(this.calculationObj.orig_params.property_type)"
                                     class="col-md-6"
                                >
                                    <label class="form-label">
                                        {{ $t('parameters.countable_area') }}
                                    </label>
                                    <div class="form-group">
                                        <div class="form-row">
                                            <div class="col-12 col-md-6 d-flex align-items-center mb-2 mb-lg-0">
                                                <span class="d-inline mr-1">{{ $t('prepositions.from') }}</span>
                                                <div class="input-group mb-0">
                                                    <input v-model="areaFrom" type="number" min="0" class="form-control"
                                                           placeholder="" aria-label="counted size"
                                                           name="area_from" aria-describedby="area_from">
                                                    <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        m<sup>2</sup>
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6 d-flex align-items-center">
                                                <span class="d-inline mr-1">{{ $t('prepositions.to') }}</span>
                                                <div class="input-group mb-0">
                                                    <input v-model="areaTo" type="number" min="0" class="form-control"
                                                           placeholder="" aria-label="counted size"
                                                           name="area_to" aria-describedby="area_to">
                                                    <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        m<sup>2</sup>
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-md-6">
                                    <label class="form-label">
                                        {{ $t('parameters.land_area') }}
                                    </label>
                                    <div class="form-group">
                                        <div class="form-row">
                                            <div class="col-12 col-md-6 d-flex align-items-center mb-2 mb-lg-0">
                                                <span class="d-inline mr-1">{{ $t('prepositions.from') }}</span>
                                                <div class="input-group mb-0">
                                                    <input v-model="landAreaFrom" type="number" min="0"
                                                           class="form-control" placeholder="" aria-label="counted size"
                                                           name="land_area_from" aria-describedby="land_area_from">
                                                    <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        m<sup>2</sup>
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6 d-flex align-items-center">
                                                <span class="d-inline mr-1">{{ $t('prepositions.to') }}</span>
                                                <div class="input-group mb-0">
                                                    <input v-model="landAreaTo" type="number" min="0"
                                                           class="form-control" placeholder="" aria-label="counted size"
                                                           name="land_area_to" aria-describedby="land_area_to">
                                                    <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        m<sup>2</sup>
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label">
                                        {{ $t('parameters.age') }}
                                    </label>
                                    <div class="form-row">
                                        <div class="col-12 col-md-6 d-flex align-items-center mb-2 mb-lg-0">
                                            <span class="d-inline mr-1">{{ $t('prepositions.from') }}</span>
                                            <div class="input-group mb-0">
                                                <input v-model="dateFrom" name="date_from"
                                                       class="form-control border-radius-20-left datepicker"
                                                       type="text">
                                                <div class="input-group-append">
                                            <span class="input-group-text">
                                                 <i class="fas fa-calendar"></i>
                                            </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6 d-flex align-items-center">
                                            <span class="d-inline mr-1">{{ $t('prepositions.to') }}</span>
                                            <div class="input-group mb-0">
                                                <input v-model="dateTo" name="date_to"
                                                       class="form-control border-radius-20-left datepicker"
                                                       type="text">
                                                <div class="input-group-append">
                                            <span class="input-group-text">
                                                 <i class="fas fa-calendar"></i>
                                            </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div v-if="['flat', 'house'].includes(this.calculationObj.orig_params.property_type)">

                                <div v-if="['flat', 'house'].includes(this.calculationObj.orig_params.property_type)"
                                     class="form-group">
                                    <label class="form-label">
                                        {{ $t('parameters.form.names.rating') }}
                                    </label>
                                    <div class="custom-checkbox-lg custom-checkbox-lg--inline">
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="rating" type="checkbox" class="custom-control-input"
                                                   id="rating-01" name="rating[]"
                                                   value="1"
                                            >
                                            <label class="custom-control-label"
                                                   for="rating-01">{{ $t('parameters.form.rating.bad') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="rating" type="checkbox" class="custom-control-input"
                                                   id="rating-02" name="rating[]"
                                                   value="2"
                                            >
                                            <label class="custom-control-label" for="rating-02">{{
                                                    $t('parameters.form.rating.nothing_much')
                                                }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="rating" type="checkbox" class="custom-control-input"
                                                   id="rating-03" name="rating[]"
                                                   value="3"
                                            >
                                            <label class="custom-control-label"
                                                   for="rating-03">{{ $t('parameters.form.rating.good') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="rating" type="checkbox" class="custom-control-input"
                                                   id="rating-04" name="rating[]"
                                                   value="4"
                                            >
                                            <label class="custom-control-label"
                                                   for="rating-04">{{ $t('parameters.form.rating.very_good') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="rating" type="checkbox" class="custom-control-input"
                                                   id="rating-05" name="rating[]"
                                                   value="5"
                                            >
                                            <label class="custom-control-label"
                                                   for="rating-05">{{ $t('parameters.form.rating.excellent') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="newBuilding" type="checkbox" class="custom-control-input"
                                                   id="new_building" name="new_building"
                                                   value="true"
                                            >
                                            <label class="custom-control-label"
                                                   for="new_building">{{ $t('parameters.form.rating.new') }}</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="['flat'].includes(this.calculationObj.orig_params.property_type)"
                                     class="form-group">
                                    <label class="form-label">
                                        {{ $t('parameters.form.names.ownership') }}
                                    </label>
                                    <div class="custom-checkbox-lg custom-checkbox-lg--inline">
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="ownership" name="ownership[]" value="4" type="checkbox"
                                                   class="custom-control-input"
                                                   id="ownership-4"
                                            >
                                            <label class="custom-control-label" for="ownership-4">
                                                {{ $t('parameters.form.ownership.private') }}
                                            </label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="ownership" name="ownership[]" value="3" type="checkbox"
                                                   class="custom-control-input"
                                                   id="ownership-3"
                                            >
                                            <label class="custom-control-label" for="ownership-3">
                                                {{ $t('parameters.form.ownership.cooperative') }}
                                            </label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="ownership" name="ownership[]" value="1" type="checkbox"
                                                   class="custom-control-input"
                                                   id="ownership-1"
                                            >
                                            <label class="custom-control-label"
                                                   for="ownership-1">
                                                {{ $t('parameters.form.ownership.other') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="['house'].includes(this.calculationObj.orig_params.property_type)"
                                     class="form-group">
                                    <label class="form-label">
                                        {{ $t('titles.property_type') }}
                                    </label>
                                    <div class="custom-checkbox-lg custom-checkbox-lg--inline">
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="houseType" name="house_type[]" value="2" type="checkbox"
                                                   class="custom-control-input"
                                                   id="houseType-2"
                                            >
                                            <label class="custom-control-label"
                                                   for="houseType-2">{{ $t('property_type.family_house') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="houseType" name="house_type[]" value="5" type="checkbox"
                                                   class="custom-control-input"
                                                   id="houseType-5"
                                            >
                                            <label class="custom-control-label"
                                                   for="houseType-5">{{ $t('property_type.hut') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="houseType" name="house_type[]" value="4" type="checkbox"
                                                   class="custom-control-input"
                                                   id="houseType-4"
                                            >
                                            <label class="custom-control-label"
                                                   for="houseType-4">{{ $t('property_type.cottage') }}</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="['flat', 'house'].includes(this.calculationObj.orig_params.property_type)"
                                     class="form-group">
                                    <label class="form-label">
                                        {{ $t('parameters.form.names.construction') }}
                                    </label>
                                    <div class="custom-checkbox-lg custom-checkbox-lg--inline">
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="construction" name="construction[]" value="4"
                                                   type="checkbox" class="custom-control-input"
                                                   id="construction-4"
                                            >
                                            <label class="custom-control-label" for="construction-4">
                                                {{ $t('parameters.form.constructions.brick') }}
                                            </label>
                                        </div>
                                        <div v-if="['flat'].includes(this.calculationObj.orig_params.property_type)"
                                             class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="construction" name="construction[]" value="6"
                                                   type="checkbox" class="custom-control-input"
                                                   id="construction-6"
                                            >
                                            <label class="custom-control-label" for="construction-6">
                                                {{ $t('parameters.form.constructions.panel') }}</label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="construction" name="construction[]" value="7"
                                                   type="checkbox" class="custom-control-input"
                                                   id="construction-7"
                                            >
                                            <label class="custom-control-label" for="construction-7">
                                                {{ $t('parameters.form.constructions.mixed') }}</label>
                                        </div>
                                        <div v-if="['house'].includes(this.calculationObj.orig_params.property_type)"
                                             class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="construction" name="construction[]" value="2"
                                                   type="checkbox" class="custom-control-input"
                                                   id="construction-2"
                                            >
                                            <label class="custom-control-label" for="construction-2">
                                                {{ $t('parameters.form.constructions.wood') }}
                                            </label>
                                        </div>
                                        <div class="custom-checkbox-lg__item custom-control custom-checkbox">
                                            <input v-model="construction" name="construction[]" value="1"
                                                   type="checkbox" class="custom-control-input"
                                                   id="construction-1"
                                            >
                                            <label class="custom-control-label" for="construction-1">
                                                {{ $t('parameters.form.constructions.other') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div v-show="this.displayRecords">
                            <div class="table-responsive">
                                <table class="table compared-table table-hover text-secondary mb-0">
                                    <thead>
                                    <tr role="row">
                                        <th></th>
                                        <th class="text-uppercase">{{ $t('record_search.table.area') }}</th>
                                        <th class="text-uppercase">{{ $t('record_search.table.price') }}</th>
                                        <th class="text-uppercase">{{ $t('record_search.table.pairing_status') }}</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(record, index) in this.records" v-on:click="openAdvert($event, record.hash)" :key="index">
                                        <td class="realty-info">
                                            <thumbnails-search
                                                :title="'#' + record.id"
                                                :record="record.hash"
                                                :route-images="routeImages"
                                            ></thumbnails-search>
                                            <div class="d-block align-middle">
                                                <span class="strong">{{ record.title }}</span>
                                                <br>
                                                <span v-if="record.new_building"
                                                      :class="'badge new badge-' + record.rating"
                                                >
                                                    {{ $t('parameters.form.rating.new') }}
                                                </span>
                                                <span v-else :class="'badge badge-' + record.rating">
                                                    {{ record.rating_string }}
                                                </span>
                                            </div>


                                            <div class="address-and-views">
                                                <div class="views-buttons-group text-left">
                                                <span class="pano-view-toggle" :data-id="record.id"
                                                      :data-toggle="'#pano-view-filter-' + record.id"
                                                      title="zobrazit na Mapy.cz Panorama"
                                                      v-on:click="displayPanorama($event)">
                                                    <img src="/img/icons/pano-view.svg">
                                                </span>

                                                    <span class="street-view-toggle" :data-id="record.id"
                                                          :data-toggle="'#street-view-filter-' + record.id"
                                                          title="zobrazit na Google Street View"
                                                          v-on:click="displayStreetView($event)">
                                                    <img src="/img/icons/street-view.svg">
                                                </span>
                                                    <div :id="'pano-view-filter-' + record.id" :data-id="record.id"
                                                         :data-location="record.location" :data-api="panoramaApi"
                                                         class="pano-view"
                                                         :class="{'pano-view--bottom': index < 2}">
                                                        <div class="close" v-on:click="hideViews">
                                                            &times;
                                                        </div>
                                                    </div>
                                                    <div :id="'street-view-filter-' + record.id"
                                                         :data-id="record.id"
                                                         :data-location="record.location" :data-api="streetviewKey"
                                                         :data-azimuth="record.streetView.azimuth ? record.streetView.azimuth : 210"
                                                         class="street-view"
                                                         :class="{'pano-view--bottom': index < 2}">
                                                        <div class="close" v-on:click="hideViews">
                                                            &times;
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="address">
                                                    {{ record.address }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{ record.usable_area }}&nbsp;m<sup>2</sup></td>
                                        <td>
                                            <p class="mb-0">{{ record.price }}</p>
                                            <p class="mb-0 font-sm text-muted">{{ record.price_m2 }}/m²</p>
                                        </td>
                                        <td class="pair-cell" :data-id="record.id">
                                            <div class="loader show"></div>
                                        </td>
                                        <td style="text-align: center">
                                            <label class="checkbox-wrapper">
                                                <input :value="record.id" name="chosenRecords[]" type="checkbox"
                                                       v-model="chosenRecords">
                                                <span class="check-button"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
<!--                            <div class="views">-->
<!--                                <div v-for="record in this.records" class="record">-->
<!--                                    <div :id="'pano-view-filter-' + record.id" :data-id="record.id"-->
<!--                                         :data-location="record.location" :data-url="panoramaRoute" class="pano-view">-->
<!--                                        <div class="close" v-on:click="hideViews">-->
<!--                                            &times;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div :id="'street-view-filter-' + record.id" :data-id="record.id"-->
<!--                                         :data-location="record.location" :data-api="streetviewKey" class="street-view">-->
<!--                                        <div class="close" v-on:click="hideViews">-->
<!--                                            &times;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                            <!--                            <div class="text-center">-->
                            <!--                                <div class="btn btn-primary" v-on:click="sendForm">ULOŽIT</div>-->
                            <!--                            </div>-->
                        </div>

                        <!--                    <div class="modal-footer d-block">-->
                        <!--                        <div class="row">-->
                        <!--                            <div class="col-md-2">-->
                        <!--                                <div :class="'loader ' + (this.timeout != null ? 'show' : 'hide')"></div>-->
                        <!--                            </div>-->

                        <!--                        </div>-->
                        <!--                    </div>-->
                    </div>
                    <div class="modal-footer justify-content-center justify-content-lg-end">
                        <div v-show="!this.displayRecords">
                            <div class="d-flex justify-content-center">
                                <div class="mr-2">
                                    <button type="button" class="btn btn-secondary text-uppercase"
                                            v-on:click="display(false)">{{ $t('buttons.close') }}
                                    </button>
                                </div>
                                <div>
                                    <div :class="'btn btn-primary ' + (this.count < this.limit ? '' : 'disabled')"
                                         v-on:click="displayRecordList"
                                    >
                                        <span class="d-inline-block text-uppercase">{{ $t('buttons.show') }}</span>
                                        <span class="text-uppercase" v-if="this.count < this.limit">
                                            <span class="d-inline-block d-md-none">
                                                ( {{ this.count }} )
                                            </span>
                                            <span class="d-none d-md-inline-block">
                                                {{ $tc('result', this.count) }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p v-if="!(this.count < this.limit)" class="small text-danger mb-0">
                                    {{ $tc('record_search.search_results_count', this.limit) }}
                                </p>
                            </div>
                        </div>

                        <div v-show="this.displayRecords">

                            <div class="btn btn-secondary text-uppercase mr-2" v-on:click="displayRecordList(false)">
                                <i class="fas fa-arrow-left mr-1"></i>
                                {{ $t('record_search.btn_back') }}
                            </div>
                            <div class="btn btn-primary text-uppercase" v-on:click="sendForm">{{ $t('buttons.save') }}
                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
</template>

<script>
import ThumbnailsSearch from './partials/thumbnails-search'
import DistrictSelect from "./forms/includes/DistrictSelect.vue";

export default {
    name: "record-search",

    props: ['route', 'calculation', 'limit', 'routeAdvert', 'routeImages', 'routePaired', 'lists', 'streetviewKey', 'panoramaApi'],

    components: {DistrictSelect, ThumbnailsSearch},

    data: function () {
        return {
            timeout: null,
            calculationObj: null,
            range: 2,
            district: {text: null, value: null},
            areaFrom: null,
            areaTo: null,
            landAreaFrom: null,
            landAreaTo: null,
            dateFrom: null,
            dateTo: null,
            newBuilding: null,
            rating: [],
            ownership: [],
            construction: [],
            houseType: [],
            count: 0,
            records: null,
            displayRecords: false,
            displayModal: false,
            chosenRecords: [],
            listsObj: null,
            axios: null,
        }
    },

    created: function () {
        this.calculationObj = JSON.parse(this.calculation)
        this.address = this.calculationObj.orig_params.place
        this.listsObj = JSON.parse(this.lists)
    },

    mounted: function () {
        let self = this

        $(".record-search-wrapper .btn.js-btn-toggle").on('click', function () {
            let myRange = document.querySelector('#myRange');

            if (myRange.dataset.inited == "false") {
                let myValue = document.querySelector('#myValue');
                let myUnits = 'Km';
                let off = myRange.offsetWidth / (parseInt(myRange.max) - parseInt(myRange.min));
                let px = ((myRange.valueAsNumber - parseInt(myRange.min)) * off) - (myValue.offsetParent.offsetWidth / 2);

                myValue.parentElement.style.left = px + 'px';
                myValue.parentElement.style.top = myRange.offsetHeight + 'px';
                myValue.innerHTML = myRange.value + ' ' + myUnits;

                myRange.oninput = function () {
                    let px = ((myRange.valueAsNumber - parseInt(myRange.min)) * off) - (myValue.offsetWidth / 2);

                    if (myRange.value == 0) {
                        myValue.innerHTML = '0.5' + myUnits;
                        myValue.parentElement.style.left = px + 'px';
                    } else {
                        myValue.innerHTML = myRange.value + ' ' + myUnits;
                        myValue.parentElement.style.left = px + 'px';
                    }
                };

                myRange.dataset.inited = "true"
            }
        });

        $(".record-search-wrapper input").on('input', this.search)
        $(".record-search-wrapper select").on('change', this.search)

        $(this.$refs.modal).on('click', function (e) {
            if ($(e.target).hasClass('modal')) {
                self.display(false)
            }
        })

        this.chosenRecords = this.calculationRecords

        this.setDefaults()

        this.axios = require('axios')
    },

    methods: {
        display: function (state = false) {
            this.displayModal = state

            if (state) {
                $('body').css({'overflow': 'hidden'});
                $(document).bind('scroll', function () {
                });

                this.search()
            } else {
                $(document).unbind('scroll');
                $('body').css({'overflow': 'visible'});
            }
        },

        search: function () {
            this.callBackend(true)
        },

        displayRecordList: function (state = true) {
            if (this.timeout == null && this.count < this.limit && this.count > 0) {
                this.displayRecords = state

                if (state) {
                    this.callBackend()
                } else {
                    this.records = null
                    this.chosenRecords = this.calculationRecords
                }
            }
        },

        callBackend: function (countOnly = false) {
            let self = this
            let timeout = countOnly ? 1000 : 0


            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.timeout = setTimeout(function () {
                let axios = require('axios')
                let data = self.data

                data.count_only = countOnly ? 1 : 0;

                let config = {
                    method: 'get',
                    url: self.route,
                    params: data,
                    headers: {}
                };

                axios(config)
                    .then(function (response) {
                        self.count = response.data.count
                        if (!countOnly) {
                            self.records = response.data.records
                            self.fetchCandidate(Object.keys(self.records)[0])
                        }

                        self.validationCheck(response.data)
                        self.timeout = null
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.validationCheck(error.data)
                        self.timeout = null
                    })
            }, timeout)
        },

        fetchCandidate: function (key) {
            let next = parseInt(key) + 1
            let self = this

            let config = {
                method: 'get',
                url: this.routePaired + '/' + this.records[key].id,
                headers: {}
            };

            axios(config)
                .then(function (response) {
                    $('.pair-cell[data-id="' + self.records[key].id + '"]').html(response.data)

                    if (self.records[next]) {
                        self.fetchCandidate(next)
                    }
                })
                .catch(function (error) {
                    if (self.records[next]) {
                        self.fetchCandidate(next)
                    }
                })
        },

        sendForm: function () {
            if (this.timeout == null) {
                //this.displayModal = false

                let hash = this.calculationObj.parent_hash ? this.calculationObj.parent_hash : this.calculationObj.hash
                localStorage.setItem('filter-' + hash, JSON.stringify({
                    range: this.range,
                    district: this.district,
                    areaFrom: this.areaFrom,
                    areaTo: this.areaTo,
                    landAreaFrom: this.landAreaFrom,
                    landAreaTo: this.landAreaTo,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    newBuilding: this.newBuilding,
                    rating: this.rating,
                    ownership: this.ownership,
                    construction: this.construction,
                    houseType: this.houseType
                }))

                $('button[name="submit-filter"]').click()
                this.timeout = true
            }
        },

        openAdvert: function (event, hash) {
            if ($(event.target).closest('.views-buttons-group, .checkbox-wrapper').length < 1) {
                let url = decodeURI(this.routeAdvert)
                url = url.replace('<ADVERT_HASH>', hash)

                window.open(url + "?close=1", "_blank")
            }
        },

        formatDate: function (date) {
            date = (typeof date !== 'undefined') ? date : new Date()

            let dd = date.getDate()
            let mm = date.getMonth() + 1
            let yyyy = date.getFullYear()

            if (dd < 10) {
                dd = '0' + dd
            }
            if (mm < 10) {
                mm = '0' + mm
            }

            return dd + '.' + mm + '.' + yyyy
        },

        isoDate: function (date) {
            if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
                return date
            }

            let arrDate = []

            try {
                arrDate = date.split('.')
            } catch (error) {
            }

            arrDate[0] = parseInt(arrDate[0])
            arrDate[0] = arrDate[0] < 10 ? '0' + arrDate[0] : arrDate[0]

            arrDate[1] = parseInt(arrDate[1])
            arrDate[1] = arrDate[1] < 10 ? '0' + arrDate[1] : arrDate[1]

            if (arrDate.length === 3) {
                return arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0]
            }

            return null
        },

        flipArray: function (array) {
            return Object.keys(array)
                .reduce(function (obj, key) {
                    obj[array[key]] = key;
                    return obj;
                }, {});
        },

        setDefaults: function () {
            this.$set(this.rating, 0, this.flipArray(this.listsObj['rating'])[this.calculationObj.orig_params.rating])

            if (this.calculationObj.orig_params.ownership) {
                this.$set(this.ownership, 0, this.flipArray(this.listsObj['ownership'])[this.calculationObj.orig_params.ownership])
            }
            if (this.calculationObj.orig_params.construction) {
                this.$set(this.construction, 0, this.flipArray(this.listsObj['construction'])[this.calculationObj.orig_params.construction])
            }
            if (this.calculationObj.orig_params.house_type) {
                this.$set(this.houseType, 0, this.flipArray(this.listsObj['house_type'])[this.calculationObj.orig_params.house_type])
            }
            if (this.calculationObj.orig_params.new_building) {
                this.newBuilding = true
            }

            this.areaFrom = this.calculationObj.result.records.reduce(function (prev, curr) {
                return prev.calc_area < curr.calc_area ? prev : curr;
            }).calc_area;
            this.areaTo = this.calculationObj.result.records.reduce(function (prev, curr) {
                return prev.calc_area > curr.calc_area ? prev : curr;
            }).calc_area;

            this.landAreaFrom = this.calculationObj.result.records.reduce(function (prev, curr) {
                return prev.lot_area < curr.lot_area ? prev : curr;
            }).lot_area;
            this.landAreaTo = this.calculationObj.result.records.reduce(function (prev, curr) {
                return prev.lot_area > curr.lot_area ? prev : curr;
            }).lot_area;


            this.dateFrom = this.formatDate(new Date(this.calculationObj.filter_date_from))
            this.dateTo = this.formatDate(new Date(this.calculationObj.filter_date_to))
            let inputs = localStorage.getItem('filter-' + this.calculationObj.parent_hash)
            if (inputs) {
                inputs = JSON.parse(inputs)

                this.range = inputs['range']
                this.district = inputs['district']
                this.areaFrom = inputs['areaFrom']
                this.areaTo = inputs['areaTo']
                this.landAreaFrom = inputs['landAreaFrom']
                this.landAreaTo = inputs['landAreaTo']
                this.dateFrom = inputs['dateFrom']
                this.dateTo = inputs['dateTo']
                this.newBuilding = inputs['newBuilding']
                this.rating = inputs['rating']
                this.ownership = inputs['ownership']
                this.construction = inputs['construction']
                this.houseType = inputs['houseType']
            }
        },

        displayPanorama: function (event) {
            $('.street-view, .pano-view, .aerial-map').removeClass('visible');

            var target = $($(event.target).closest('.pano-view-toggle').data('toggle'));

            if (!target.hasClass('visible')) {
                const container = document.querySelector("#pano-view-filter-" + target.data('id'));
                let gps = target.data('location').split(",")

                if (target.find('canvas').length === 0) {
                    const pano = Panorama.panoramaFromPosition({
                        parent: container,
                        lon: gps[1],
                        lat: gps[0],
                        apiKey: target.data('api'),
                        showNavigation: true,
                    });

                    if (pano.error) {
                        target.textContent = `Code: ${pano.errorCode}\nMsg: ${pano.error}`;
                    }
                }
            }

            target.toggleClass('visible');
        },

        displayStreetView: function (event) {
            $('.street-view, .pano-view, .aerial-map').removeClass('visible');

            var target = $($(event.target).closest('.street-view-toggle').data('toggle'));

            if (!target.hasClass('visible')) {
                if (target.find('iframe').length == 0) {
                    target.append($('<iframe>', {
                        width: 300,
                        height: 225,
                        src: 'https://www.google.com/maps/embed/v1/streetview\n' +
                            '?key=' + target.data('api') +
                            '&location=' + target.data('location') +
                            '&heading=' + (target.data('azimuth') ? target.data('azimuth') : 210) +
                            '&pitch=5' +
                            '&fov=90' +
                            '&source=outdoor',
                        frameborder: 0,
                        style: "border: 0"
                    }));
                }
            }

            target.toggleClass('visible');
        },

        hideViews: function () {
            $('.street-view, .pano-view, .aerial-map').removeClass('visible');
        },

        isOverflown: function (element) {
            return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
        },

        validationCheck: function (data) {
            $('.record-search-wrapper input').removeClass('err')

            if (data.wrong_values && data.wrong_values.length > 0) {
                let casts = {
                    'last_seen_at': ['date_from', 'date_to'],
                    'calc_area': ['area_from', 'area_to'],
                    'lot_area': ['land_area_from', 'land_area_to']
                }

                for (let key in data.wrong_values) {
                    let names = casts[data.wrong_values[key]]

                    for (let inputKey in names) {
                        $('.record-search-wrapper input[name="' + names[inputKey] + '"]').addClass('err')
                    }
                }
            }
        }
    },

    computed: {
        data: function () {
            return {
                addr: this.calculationObj.orig_params.place,
                district: this.district.text,
                property_type: this.calculationObj.orig_params.property_type,
                kind: this.calculationObj.orig_params.kind,
                max_dist: this.range == 0 ? 0.5 * 1000 : this.range * 1000,
                query: {
                    last_seen_at: {from: this.isoDate(this.dateFrom), to: this.isoDate(this.dateTo)},
                    calc_area: {from: this.areaFrom, to: this.areaTo},
                    lot_area: {from: this.landAreaFrom, to: this.landAreaTo},
                    rating_id: this.rating,
                    ownership_id: this.ownership,
                    construction_id: this.construction,
                    new_building: this.newBuilding,
                    house_type_id: this.houseType,
                }
            }
        },

        jsonRecords: function () {
            return JSON.stringify(this.chosenRecords)
        },

        calculationRecords: function () {
            let records = [];
            for (let i in this.calculationObj.result.records) {
                records.push(this.calculationObj.result.records[i].id)
            }

            return records
        }
    }
}
</script>

<style scoped>
.modal-content {
    min-height: 75vh;
}

.modal.show {
    display: block;
    overflow: auto;
}

.overflow-y {
    overflow-y: scroll;
}

a.image {
    text-decoration: underline !important;
    white-space: nowrap;
    margin-right: 7.5px;
}

a.image:hover {
    text-decoration: none !important;
}

.table th {
    border-top: none !important;
}

.table tr td:first-of-type, .table tr th:first-of-type {
    width: 40% !important;
}

.table tr td, .table tr th {
    width: 15% !important;
}

.table input[type="checkbox"] {
    transform: scale(1.2);
}

.datepicker {
    padding: 0.5rem 1.125rem !important;
}

/*.datepicker-group .fas {*/
/*    top: calc(50% - 4px) !important;*/
/*}*/

.searched-counter.err {
    color: red !important;
}

input.err:not(.searched-counter) {
    border-color: red;
}

.views {
    position: absolute;
    width: 100%;
    z-index: 10;
}

.checkbox-wrapper {
    position: relative;
    margin-bottom: 0;
}

.checkbox-wrapper .check-button {
    position: relative;
    z-index: 2;
    display: inline-block;
    border: 1px solid silver;
    border-radius: 25px;
    text-align: center;
    padding-top: 4px;
    font-weight: 600;
    font-size: 12px;
    height: 32px;
    color: #20cba3;
    width: 100px;
    cursor: pointer;
    text-align: center
}

.checkbox-wrapper .check-button:before {
    content: 'VYBRAT';
    font-weight: 600;
    font-size: 14px;
    color: #20cba3;
    position: relative;
    text-align: center;
}

.checkbox-wrapper input {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 10px;
    opacity: 0;
}

.checkbox-wrapper input:checked + .check-button:before {
    content: 'VYBRÁNO';
    color: white;
    background-color: #20cba3;
}

.checkbox-wrapper input:checked + .check-button {
    background-color: #20cba3;
}

.check-button:hover {
    background-color: rgba(32, 203, 163, .20);
}

.pair-cell {
    position: relative;
}

.pair-cell .loader {
    left: calc(50% - 10px) !important;
}
</style>
